<template>
    <div>
        <form @submit.prevent="login" class="form">
            <div v-if="error" class="alert-message">Login ou senha inválido</div>
            <div>
                <label class="white-text">Nome de usuário ou endereço de e-mail</label>
                <input type="text" class="input" v-model="username">
            </div>
            <div>
                <label class="white-text">Senha</label>
                <input type="password" class="input" v-model="password">
            </div>
            <div>
                <button class="button" :disabled="carregando">
                    {{ carregando ? 'CARREGANDO' : 'ACESSAR'}}
                </button>
            </div>
            <div class="mt-5 center-align">
                 <router-link :to="{name:'solicitar_recuperar_senha'}">Esqueceu a senha?</router-link>
            </div>
        </form>
    </div>
</template>

<script>


import Auth from '@/store/auth';
import { login, api } from '@/helpers/api';

export default {


    data() {
        return {
            username: null,
            password: null,
            empresa: null,
            error: false,
            carregando: false
        }
    },

    methods: {

        async login() {

            this.error = false;
            this.carregando = true;

            try {
                const {data: {token, usuario, usuario_id}} = await login(this.username, this.password);
                await Auth.set(token, usuario_id, usuario);

                Auth.changeStyle()
            } catch (e) {
                this.error = true;
                return;
            } finally {
                this.carregando = false;
            }

            this.$router.push('/');
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/auth/LoginNovo.vue